import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useBridgeAPI, useBridgeState } from '@digitaz/bridge-sdk-client';
import { ensureHTTPProtocolInWebsiteUrl } from '../../../utils/helpers';

const BridgeLink = memo(({ href, children, ...rest }) => {
  const { isWebView } = useBridgeState();
  const { openUrl } = useBridgeAPI();

  const onClick = e => {
    if (isWebView) {
      e.preventDefault();
      openUrl(ensureHTTPProtocolInWebsiteUrl(href));
    }
  };

  return (
    <a onClick={onClick} href={href} {...rest}>
      {children}
    </a>
  );
});

BridgeLink.displayName = `BridgeLink`;

BridgeLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node
};

export default BridgeLink;
